module.exports = __webpack_public_path__ + "static/media/indianpoker.9d44263f.png";